import { mapState, mapActions, mapGetters, mapMutations } from "vuex"

import profile_infos from "./contextMenu/profileInfos"

import nav_context_menu_band from "./contextMenu/band"
import nav_context_menu_shared from "./contextMenu/shared"

import cache_mixin from "~/mixins/cache"
import acc_swapper_mixin from "~/mixins/nav/accSwapper"

export default {
  mixins: [cache_mixin, acc_swapper_mixin],
  components: {
    profile_infos,
    nav_context_menu_band,
    nav_context_menu_shared,
  },
  computed: {
    isValidUser: function () {
      return this.has_selected_band || this.is_inf
    },
    selectedData: function () {
      return this.selectedBandData || this.infData
    },
    ...mapState({
      has_selected_band: (state) => state.user.band.id,
      infData: (state) => state.user.influencer,
    }),
    ...mapGetters({
      selectedBandData: "user/band/BAND_DATA",
      is_agency: "user/IS_AGENCY",
      is_inf: "user/IS_INF",
      is_band: "user/IS_BAND",
      kind: "user/KIND",
    }),
  },
  methods: {
    logout: function () {
      this.cleanCacheAll()
      if (this.is_band) this.SET_LOGIN_OUT()
      this.store_logout()
    },
    ...mapActions({
      store_logout: "user/LOGOUT",
    }),
    ...mapMutations({
      SET_LOGIN_OUT: "misc/draft/SET_LOGIN_OUT",
    }),
  },
}
